<template>
    <div class="user-pay-statistics body-box">
        <div class="user-pay-statistics-left">
             <Tree @changeSwitch="changeSwitch" @nodeClick="nodeClick"></Tree>
        </div>
        <div class="user-pay-statistics-right">
            <TabelSearch :searchConfig="searchConfig"   :searchParams="searchParams" @resetCallBack="resetCallBack" @search="setSearchParams"></TabelSearch>
            <Table :width="'100%'"
                   :tableLoading="tableLoading"
                   :tabelButtons="tabelButtons"
                   :templateData="tableTemplateData"
                   :tableConfig="tableConfig"
                   :pagination="pagination">
            </Table>
        </div>
        <el-dialog
                :close-on-click-modal="false" :close-on-press-escape="false"
                title="付费记录"
                :visible.sync="dialogVisible"
                width="1200px"
                :before-close="handleClose">
                <Table :width="'100%'"
                       :tableLoading="tableLoading2"
                       :tabelButtons="tabelButtons2"
                       :templateData="tableTemplateData2"
                       :tableConfig="tableConfig2"
                       :pagination="pagination2">
                </Table>
        </el-dialog>
    </div>
</template>

<script>
    import Table from "../../../../components/table/table";
    import TabelSearch from '../../../../components/tabel-search/tabel-search'
    import Tree from '../../../../components/Tree/nodeTree'
    import {userApi} from "../../../../api-path/user-api";
    export default {
        name: "user-pay-statistics",
        components:{Table,TabelSearch,Tree},
        data(){
            return{
                dialogVisible:false,
                searchParams: {
                    areaId:'',
                    isDown:false,
                    tags:'',
                    page:1,
                    size:10,
                },
                searchParams2: {
                    page:1,
                    size:10,
                },
                searchConfig2:{
                    dataName: 'searchParams2',
                    items: []
                },
                searchConfig: {
                    dataName: 'searchParams',
                    items: [
                        {
                            key: 'tags',
                            placeholder: '输入姓名/手机号查询',
                        },

                    ]
                },
                //表格
                tableLoading2: false,
                tableLoading: false,
                tableTemplateData: [],
                tableTemplateData2: [],
                tabelButtons: [ ],
                tabelButtons2: [ ],
                tableConfig: {
                    checkbox: false,
                    rows: [
                        {
                            label: '真实姓名',
                            prop: 'userName',
                        }, {
                            label: '手机',
                            prop: 'phone',
                        },{
                            label: '申请区域',
                            prop: 'areaName',
                        },{
                            label: '访问时长',
                            prop: 'playTime',
                        },{
                            label: '费用',
                            prop: 'cost',

                        },
                    ],
                    rowButtons:{
                        width:'100px',
                        items: [
                            {
                                label: '查看',
                                fn:(data)=> {
                                    this.searchParams2.userId=data.userId;
                                    this.startSearch2()
                                    this.dialogVisible=true;

                                }
                            },

                        ],
                    },
                },
                tableConfig2: {
                    checkbox: false,
                    rows: [
                        {
                            label: '摄像机名称',
                            prop: 'name',
                        }, {
                            label: '摄像机地址',
                            prop: 'address',
                        },{
                            label: '开始时间',
                            prop: 'startTime',
                        },{
                            label: '结束时间',
                            prop: 'endTime',
                        },
                    ],

                },
                pagination: {
                    show: true,
                    total: 0,
                    page: 1,
                    size: 10,
                    sizeChange: this.sizeChange,
                    pageChange: this.pageChange,
                }, // 分页
                pagination2: {
                    show: true,
                    total: 0,
                    page: 1,
                    size: 10,
                    sizeChange: this.sizeChange2,
                    pageChange: this.pageChange2,
                }, // 分页
            }
        },
        methods:{
            changeSwitch(e){
                this.searchParams.isDown=e;
				this.isDown=e;
                this.startSearch();
            },
            nodeClick(node){
                this.searchParams.areaId=node.id;
				this.areaId=node.id;
                this.searchParams.page=this.pagination.page=1;
                this.startSearch()
            },
            startSearch(){
                console.log(this.searchParams)
                this.$http.get(userApi.cameraPlaybackList,{params:this.searchParams}).then(res=>{
                    if(res.status==200){
                        this.tableTemplateData=res.result.pageList;
                        this.pagination.total=res.result.total;
                    }
                })
            },
            resetCallBack(){
               this.searchParams.isDown=this.isDown;
               this.searchParams.areaId=this.areaId;
               this.searchParams.page=this.pagination.page=1;
               this.startSearch()
            },
			setSearchParams(value) {
				if(value){
					this.pagination.page=value.page;
				}
                this.startSearch()
            },
            startSearch2(){
                this.$http.get(userApi.getUserPlayList,{params:this.searchParams2}).then(res=>{
                    if(res.status==200){
                        this.tableTemplateData2=res.result.pageList;
                        this.pagination2.total=res.result.total;
                    }
                })
            },
            sizeChange(size) {
                this.pagination.size = size;
                this.searchParams.size=size;
                this.startSearch()
            },
            // 当前页
            pageChange(page) {
                this.pagination.page = page
                this.searchParams.page=page;
                this.startSearch()
            },
            sizeChange2(size) {
                this.pagination2.size = size;
                this.searchParams2.size=size;
                this.startSearch2()
            },
            // 当前页
            pageChange2(page) {
                this.pagination2.page = page
                this.searchParams2.page=page;
                this.startSearch2()
            },
            handleClose(){
                this.dialogVisible=false
            }
        },
    }
</script>

<style scoped lang="less">
    .user-pay-statistics{
        display: flex;
		margin-left: 10px;
		box-sizing: border-box;
		height: 100%;
		padding: 10px;
		border-radius: 10px;
		background: #fff;
		display: flex;
        .user-pay-statistics-left{
            margin-right: 10px;
            border-right: 1px solid #c1c1c1;
        }
        .user-pay-statistics-right{
            flex: 1;
        }
    }

</style>